import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import Session from './model';
import * as Constants from './constants';

export const fetchSessionsObservable = (institutionId, validOn, validTo, ageGroupId, includeDiscontinued) => {
    return RESTClient.getAuthenticatedObservable('v2/sessions', {
        institutionId,
        validOn,
        validTo,
        includeDiscontinued,
        ageGroupIds: ageGroupId,
        behaviors: 1,
    }).map(sessionData => ({
        sessions: sessionData.sessions.map(Session.fromAPI),
        behaviors: new BehaviorsCollection(sessionData.behaviors),
    }));
};

export const createSession = session => {
    return RESTClient.postAuthenticatedObservable('v2/sessions', {session}).map(newSessionData => ({
        session: Session.fromAPI(newSessionData.session),
    }));
};

export const updateSession = (session, force = false) => {
    return RESTClient.putAuthenticatedObservable(
        `v2/sessions?force=${force}`,
        {session},
        {
            ignoredErrors: [Constants.RequiresForceUpdateErrorCode],
        },
    ).map(newSessionData => ({
        session: Session.fromAPI(newSessionData.session),
    }));
};

export const updateSessions = (sessions, force = false) => {
    return RESTClient.putAuthenticatedObservable(
        `v2/sessions?force=${force}`,
        {sessions},
        {
            ignoredErrors: [Constants.RequiresForceUpdateErrorCode],
        },
    ).map(data => ({
        sessions: List(data.sessions).map(s => Session.fromAPI(s)),
    }));
};

export const deleteSession = session => {
    return RESTClient.deleteAuthenticatedObservable(`v2/sessions/${session.id}`, {session}).map(removedSessionData => ({
        session: Session.fromAPI(removedSessionData.session),
    }));
};

export const restoreSession = session => {
    return RESTClient.postAuthenticatedObservable(`v2/sessions/${session.id}/restore`).map(restoredSessionData => ({
        session: Session.fromAPI(restoredSessionData.session),
    }));
};

export const fetchSession = sessionId => {
    return RESTClient.getAuthenticatedObservable(`v2/sessions/${sessionId}`).map(sessionData => ({
        sessions: sessionData.map(session => Session.fromAPI(session)),
    }));
};

export const unscheduleSession = sessionId => {
    return RESTClient.postAuthenticatedObservable(`v2/sessions/${sessionId}/unschedule`).map(unscheduledData => ({
        unscheduledSessionVersionId: unscheduledData.sessionVersionId,
        remainingVersions: unscheduledData.remainingVersions.map(Session.fromAPI),
    }));
};
